import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Camera, X, Check } from 'lucide-react';
import { Button } from './ui/Button';
import { useLanguage } from '../contexts/LanguageContext';
interface PhotoTipsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenCamera: () => void;
}
export function PhotoTipsModal({
  isOpen,
  onClose,
  onOpenCamera
}: PhotoTipsModalProps) {
  const {
    t
  } = useLanguage();
  return <AnimatePresence data-id="element-272">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 z-50 backdrop-blur-sm" onClick={onClose} data-id="element-273" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-274">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden pointer-events-auto" data-id="element-275">
              <div className="p-6" data-id="element-276">
                <div className="flex items-center justify-center w-16 h-16 bg-teal-50 rounded-full mx-auto mb-6" data-id="element-277">
                  <Camera className="w-8 h-8 text-teal-deep" data-id="element-278" />
                </div>

                <h3 className="text-2xl font-bold text-center text-navy mb-6" data-id="element-279">
                  {t.problemDescription.photoTips.title}
                </h3>

                <ul className="space-y-4 mb-8" data-id="element-280">
                  <li className="flex items-start gap-3" data-id="element-281">
                    <div className="mt-1 bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-282">
                      <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-283" />
                    </div>
                    <span className="text-gray-700 text-lg" data-id="element-284">
                      {t.problemDescription.photoTips.tip1}
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-285">
                    <div className="mt-1 bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-286">
                      <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-287" />
                    </div>
                    <span className="text-gray-700 text-lg" data-id="element-288">
                      {t.problemDescription.photoTips.tip2}
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-289">
                    <div className="mt-1 bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-290">
                      <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-291" />
                    </div>
                    <span className="text-gray-700 text-lg" data-id="element-292">
                      {t.problemDescription.photoTips.tip3}
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-293">
                    <div className="mt-1 bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-294">
                      <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-295" />
                    </div>
                    <span className="text-gray-700 text-lg" data-id="element-296">
                      {t.problemDescription.photoTips.tip4}
                    </span>
                  </li>
                </ul>

                <div className="flex flex-col gap-3" data-id="element-297">
                  <Button onClick={() => {
                onClose();
                onOpenCamera();
              }} className="w-full bg-teal-deep hover:bg-teal-700 text-white h-14 text-lg font-semibold" data-id="element-298">
                    {t.problemDescription.photoTips.openCamera}
                  </Button>
                  <Button variant="secondary" onClick={onClose} className="w-full h-14 text-lg bg-gray-100 text-gray-700 hover:bg-gray-200" data-id="element-299">
                    {t.problemDescription.photoTips.cancel}
                  </Button>
                </div>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}